
<template>
  <div class="container has-text-centered">
    <a
      class="m-t-xl m-b-xl is-block has-text-weight-bold"
      @click="$router.go(-1)"
    >Go back</a>
    <a
      class="m-t-xl m-b-xl is-block "
      :href="link"
      target="_blank"
    >Go to Hangfire</a>
  </div>
</template>

<script>
export default {
  computed: {
    link() {
      return `${process.env.VUE_APP_HANGFIRE_PATH}hangfire?access_token=${this.$store.getters['auth/token']}`;
    },
  },
};
</script>
